import axios from "axios";
import { logger } from "../logger";
let fonts = [];
export const GoogleServiceLib = (api_key) => {
    if (!google || !google.maps) {
        logger.captureWarning("Google Maps API not loaded");
    }
    const PlaceService = new google.maps.places.PlacesService(document.createElement("div"));
    const DistanceMatrix = new google.maps.DistanceMatrixService();
    const AutocompleteService = new google.maps.places.AutocompleteService();
    const Geocoder = new google.maps.Geocoder();
    return {
        fonts: {
            async list() {
                if (fonts.length === 0) {
                    const response = await axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${api_key}&sort=alpha`);
                    if (response.data.items) {
                        fonts = response.data.items.map((font) => ({
                            ...font,
                            value: font.family,
                            label: font.family,
                        }));
                    }
                }
                return fonts;
            },
        },
        place_get(placeId) {
            return new Promise((resolve, reject) => {
                const fields = [
                    "address_component",
                    "adr_address",
                    "formatted_address",
                    "geometry",
                    "name",
                    "place_id",
                    "type",
                ];
                PlaceService.getDetails({ fields, placeId }, (place, status) => {
                    if (status === google.maps.places.PlacesServiceStatus.OK)
                        resolve(place);
                    else
                        reject("Error finding location");
                });
            });
        },
        autocomplete_place(opts) {
            return new Promise((resolve, reject) => {
                console.log({ opts });
                AutocompleteService.getPlacePredictions(opts, (predictions, status) => {
                    if (status !== google.maps.places.PlacesServiceStatus.OK) {
                        reject("Nothing found");
                    }
                    else {
                        resolve(predictions);
                    }
                });
            });
        },
        distance_matrix(opts) {
            return new Promise((resolve, reject) => {
                DistanceMatrix.getDistanceMatrix(opts, (res, status) => {
                    if (status === google.maps.DistanceMatrixStatus.OK)
                        resolve(res);
                    else
                        reject(status);
                });
            });
        },
        geocode(opts) {
            return new Promise((resolve, reject) => {
                Geocoder.geocode(opts, (res, status) => {
                    if (status === google.maps.GeocoderStatus.OK)
                        resolve(res);
                    else
                        reject(status);
                });
            });
        },
        async cords_get_current() {
            const req = await axios.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${api_key}`);
            return req.data;
        },
        async timezone_from_cords(lat, lng) {
            const req = await axios.get(`https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${Date.now() / 1000}&key=${api_key}`);
            return req.data;
        },
    };
};
//# sourceMappingURL=index.js.map